import React, { useState, useEffect } from "react";
import "./Navbar.css";
import NavText from "./NavText";
import Button from "./Button";
import moonIcon from "./../assets/moon.png"; 
import sunIcon from "./../assets/sun.png";    

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDarkMode = () => setDarkMode(!darkMode);

  useEffect(() => {
    if (darkMode) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [darkMode]);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className='logo-text'>Sterling & Associates</div>

        <div className={`burger ${menuOpen ? "toggle" : ""}`} onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <NavText text="Home" css="text"/>
          <NavText text="About" css="text"/>
          <NavText text="Practice Areas" css="text"/>
          <NavText text="Attorneys" css="text"/>
          <NavText text="Testimonials" css="text"/>
          <NavText text="Contact" css="text"/>
        </div>

        <div className='button-container'>
          <Button text="Book Consultation" css4="button"/>
          <img
            className="image"
            src={darkMode ? sunIcon : moonIcon}
            alt="Toggle Dark Mode"
            onClick={toggleDarkMode}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;